import Axios from "axios";
import moment from "moment";
import store from "../store";
import i18n from "../i18n";

const ReservationStore = {
  namespaced: true,
  debug: true,
  state: {
    reservationDetail: [],
    mailAddress: {}
  },
  mutations: {
    setReservationDetail(state, data) {
      state.reservationDetail = data;
      console.log(state.reservationDetail);
    },
    setMailAddress(state, data) {
      state.mailAddress = data;
    }
  },
  getters: {
    getReservationDetail(state) {
      return state.reservationDetail.map(val => {
        let result = {
          schedulenumber: val.schedulenumber,
          day: moment(val.startdate).format("YYYY/MM/DD"),
          targetDate: moment(val.targetdate),
          startTime: moment(val.startdate).format("Ah:mm 開始"),
          endTime: moment(val.enddate).format("Ah:mm 終了"),
          type:
            val.type != null && val.type != ""
              ? store.getters[
                  "constantStore/constant/constantStore/getTypeData"
                ](val.type).label
              : "",
          content: val.content,
          content2: val.content2,
          noReservation: val.noreservation,
          reservationnumber: val.reservationnumber,
          confirmationnumber: val.confirmationnumber,
          buttonShow: false
        };
        if (val.status === "Reserved") {
          if(moment().isBefore(
            moment(val.startdate).subtract(
              parseFloat(process.env.VUE_APP_CLOSING_CANCEL_TIME),
              "hours"
            )
          )){
            result.buttonShow = true;
            result.buttonType = "cancel";
            result.status = i18n.t("page.reservationCommon.reserved");
          }else{
            result.status = i18n.t("page.reservationCommon.reserved");
          }
        } else {
          result.status = i18n.t("page.reservationCommon.used");
        };
        return result;
      });
    }
  },
  actions: {
    async callApiReservationList({ commit }, searchInfo) {
      commit("setMailAddress", searchInfo.searchEmailAddress);
      let reservationList = await Axios.post(
        process.env.VUE_APP_API_URL + "api/guest/reservationList",
        {
          searchReservationNumber: searchInfo.searchReservationNumber,
          searchEmailAddress: searchInfo.searchEmailAddress
        },
        {
          headers: {
            guest: true
          }
        }
      );
      commit("setReservationDetail", reservationList.data);
    },
    async callConfirmReservationDetail( context ){
      let reg = new RegExp("email:" + context.state.mailAddress + "\\s");
      let confirmReservationDetailList = context.state.reservationDetail.filter((data) => {
        return reg.test(data.detail);
      });
      context.commit("setReservationDetail", confirmReservationDetailList);
    }
  }
};
export default ReservationStore;
